import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Trans } from 'react-i18next';
import Icon from '../../../components/Icon';
import { SUPPORT_EMAIL } from '../../../constants/api';
export const TimedOutCommitBanner = () => {
    return _jsxs("div", { className: "alert alert-warning mt-4", children: [_jsx(Icon, { name: "exclamation-circle", fixedWidth: true, className: "mr-2" }), _jsxs(Trans, { i18nKey: "latestCommitTimedOut", values: { email: SUPPORT_EMAIL }, children: ["Your latest commit timed out. Please contact us at ", _jsx("a", { className: "inline", href: `mailto:${SUPPORT_EMAIL}`, children: SUPPORT_EMAIL }), "."] })] });
};
